import { Subscription } from "schemas/dashboard";

export function getFollowUpAssistantDate(subscription: Subscription | null) {
  if (!subscription?.creditsCycle) {
    return undefined;
  }

  const cycleStart = new Date(subscription.creditsCycle[0] * 1000);
  const cycleEnd = new Date(subscription.creditsCycle[1] * 1000);
  const now = new Date();

  const startDate = subscription.subscriptionStartDate
    ? new Date(subscription.subscriptionStartDate * 1000)
    : null;

  const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

  const isRecentSubscription =
    startDate !== null && now.getTime() - startDate.getTime() < THREE_DAYS_MS;
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  const isCycleStartToday =
    Math.abs(now.getTime() - cycleStart.getTime()) < ONE_DAY_MS;
  if (!isRecentSubscription && isCycleStartToday) {
    return "today";
  }

  const diffMs = cycleEnd.getTime() - now.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const daysAway = diffDays + 1;
  return daysAway;
}
